import { DashboardBaseFilterModel } from '@/dashboard/models/DashboardBaseFilterModel'

export class DashboardAmountOfSalesFilterModel extends DashboardBaseFilterModel {
    constructor(d?:Partial<DashboardAmountOfSalesFilterModel>) {
        super(d)
    }
}
